import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "./logo.png";
import "./Header.css";

function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 500);
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function handleMenuClick() {
    setMenuOpen(!menuOpen);
  }

  return (
    <div className="menu">
      <div className="logo">
        <Link to="/">
          <img src={logo} max-width="100px" alt="логотип" />
        </Link>
      </div>
      {isMobile ? (
        <div className="burger" onClick={handleMenuClick}>
          <div className="b"></div>
          <div className="b"></div>
          <div className="b"></div>
        </div>
      ) : (
        <div className="links">
          <Link to="/Docs">Документы</Link>
          <Link to="/Work">Сертификация</Link>
          <Link to="/Contacts">Контакты</Link>
        </div>
      )}
      {menuOpen && (
        <div className="linksphone">
          <Link to="/Docs" onClick={handleMenuClick}>
            Документы
          </Link>
          <Link to="/Work" onClick={handleMenuClick}>
            Сертификация
          </Link>
          <Link to="/Contacts" onClick={handleMenuClick}>
            Контакты
          </Link>
        </div>
      )}
    </div>
  );
}

export default Header;